import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { GatePage } from './pages/gate/GatePage';
import { DashboardPage } from './pages/business/DashboardPage';
import { NewCasePage } from './pages/business/NewCasePage';
import { CaseDetailPage } from './pages/business/CaseDetailPage';
import { CollateralsPage } from './pages/business/CollateralsPage';
import { CreditFacilitiesPage } from './pages/business/CreditFacilitiesPage';
import { CreditMemoPage } from './pages/business/CreditMemoPage';
import { CalculatorPage } from './pages/business/CalculatorPage';
import { TemplatesPage } from './pages/business/TemplatesPage';
import { BusinessLayout } from './components/BusinessLayout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/auth/LoginPage';
import { AuthCallbackPage } from './pages/auth/AuthCallbackPage';
import { useAuthStore } from './stores/auth';

export function App() {
  useEffect(() => useAuthStore.getState().init(), []);

  return (
    <Routes>
      {/* Gate / landing */}
      <Route path="/" element={<GatePage />} />

      {/* Auth */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />

      {/* Mortgage side — redirect to existing FAI360 */}
      <Route
        path="/mortgage"
        element={<MortgageRedirect />}
      />

      {/* Business side — protected */}
      <Route element={<ProtectedRoute />}>
        <Route path="/business" element={<BusinessLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="cases/new" element={<NewCasePage />} />
          <Route path="cases/:caseId" element={<CaseDetailPage />} />
          <Route path="cases/:caseId/facilities" element={<CreditFacilitiesPage />} />
          <Route path="cases/:caseId/collaterals" element={<CollateralsPage />} />
          <Route path="cases/:caseId/memo" element={<CreditMemoPage />} />
          <Route path="calculator" element={<CalculatorPage />} />
          <Route path="templates" element={<TemplatesPage />} />
        </Route>
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function MortgageRedirect() {
  // In production, this redirects to the existing FAI360 mortgage app
  if (typeof window !== 'undefined') {
    window.location.href = 'https://fai360.io/mortgage';
  }
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-slate-600">מעביר אותך למערכת המשכנתאות…</div>
    </div>
  );
}
